import "../ContactUs/ContactUs.scss"
import Header from "../../../Shared-Component/Header/Header.jsx"
import Footer from "../../../Shared-Component/Footer/Footer.jsx"
import { FaLocationDot } from "react-icons/fa6";
import { IoCall } from "react-icons/io5";
import { RiTwitterXFill } from "react-icons/ri";
import { RiInstagramFill } from "react-icons/ri";
import { FiFacebook } from "react-icons/fi";
import { FiLinkedin } from "react-icons/fi";
import { Button } from 'primereact/button';
import { useState } from 'react'
import { Link } from 'react-router-dom'
import CampusSlashTitle from '../../../CampusLife/CampusSharedComponent/CampusTitles/CampusSlashTitle/CampusSlashTitle.jsx'
import { useContext } from 'react'
import { AppContext } from '../../../context/AppContext.jsx'
import { InputText } from 'primereact/inputtext';
import { InputTextarea } from 'primereact/inputtextarea';
import axios from 'axios'
import { toast } from 'react-toastify';
import SuccessDialog from '../../../components/SuccessDialog.jsx';

const ContactUs = () => {

    const eMailpattern = /^\S+@\S+\.\S+$/
    const { backendUrl } = useContext(AppContext);
    const [showSuccessDialog, setShowSuccessDialog] = useState(false);
    const [loading, setLoading] = useState(false);
    const [errors, setErrors] = useState({
    });

    const [contactFormData, setContactFormData] = useState({
        name: "",
        email: "",
        message: ""
    });

    const handleChange = (e) => {
        e.preventDefault()
        let name = e.target.name
        let value = e.target.value
        setContactFormData({ ...contactFormData, [name]: value })
        setErrors((prevErrors) => ({
            ...prevErrors,
            [name]: ""
        }));
    }

    const validateForm = () => {
        const testeMailpattern = eMailpattern.test(contactFormData.email)
        const error = {};
        if (!contactFormData.name.trim()) {
            error.name = "Required"
        }
        if (!contactFormData.email.trim()) {
            error.email = "Required"
        }
        else if (!testeMailpattern) {
            error.email = "Invalid Email"
        }
        else {

        }
        if (!contactFormData.message.trim()) {
            error.message = "Required"
        }
        setErrors(error)
        return Object.keys(error).length === 0;
    };

    const clearForm = () => {
        setContactFormData({
            name: "",
            email: "",
            message: ""
        })
        setErrors({})
    };

    const handleSubmit = async (e) => {
        e.preventDefault();
        setLoading(true);
        try {
            if (validateForm()) {
                const res = await axios.post(`${backendUrl}/api/auth/submitContactForm`, contactFormData)
                if (res.data.success === true) {
                    setShowSuccessDialog(true);
                    clearForm();
                }
            }
        }
        catch (error) {
            console.error('Error fetching users:', error);
            if (error.response && error.response.status === 503) {
                toast.error("⚠️ The service is currently under maintenance. Please try again later.");
            }
            else if (!navigator.onLine) {
                toast.error("🚫 No internet connection. Please check your network.");
            }
            else if (error.request && !error.response) {
                toast.error("⚠️ Network issue or server is unreachable. Try again later.")
            }
            else if (error.response && error.response.status === 500) {
                toast.error("Internal Server Error")
                clearForm();
            }
            else {
                console.error("Unexpected error:", error);
                toast.error("Something went wrong.");
            }
        } finally {
            setLoading(false);
        }
    }

    return (
        <>
            <div>
                <Header />

                <SuccessDialog
                    visible={showSuccessDialog}
                    onHide={() => setShowSuccessDialog(false)}
                    header="Message Sent"
                    message="Your message has been sent successfully!"
                    buttonLabel="OK"
                />

                <div className='campusmaincontainer'>
                    <div className='campus-container'>
                        <CampusSlashTitle slashTitle="Contact Us" />
                        <div style={{ paddingTop: "12.5px" }}>
                            <div className='get-in-touch-conatiner'>
                                <div className='get-in-touch-subconatiner'>
                                    <div className='get-in-touch-content-container'>
                                        <div className='get-in-touch-title'>
                                            <h2>Get in Touch</h2>
                                        </div>
                                        <div className='get-in-touch-content'>
                                            <p>Let's Stay in touch! Join our mailing list to learn more about NICAS.</p>
                                        </div>
                                        <div className='get-in-touch-icons-container'>
                                            <div className='get-in-touch-icons-subcontainer'>
                                                <FaLocationDot className='get-in-touch-icons-location' style={{ marginTop: "10px" }} />
                                                <div className='get-in-touch-icons-content'>
                                                    <p>Thuckalay, Kumaracoil</p>
                                                    <p>TamilNadu 629180</p>
                                                </div>
                                            </div>
                                            <div className='get-in-touch-icons-subcontainer'>
                                                <IoCall className='get-in-touch-icons' />
                                                <div className='get-in-touch-icons-content'>
                                                    <p className='get-in-touch-icons-content-link'> <Link>04651-253766</Link></p>
                                                </div>
                                            </div>
                                            <div className='get-in-touch-icons-subcontainer'>
                                                <div className='get-in-touch-icons-socialmedia-container'>
                                                    <a href="https://www.facebook.com/rajalakshmi.saravana.714" target="_blank"><FiFacebook className="get-in-touch-icons-socialmedia" /></a>
                                                    <a href="#" target="_blank" style={{ cursor: "default" }}><FiLinkedin className="get-in-touch-icons-socialmedia" /></a>
                                                    <a
                                                        href="https://www.instagram.com/n_i_college_official?utm_source=qr&igsh=MTlpYWw4dTNmc3prZw=="
                                                        target="_blank"
                                                    ><RiInstagramFill className="get-in-touch-icons-socialmedia" />
                                                    </a>
                                                    <a href="#" target="_blank" style={{ cursor: "default" }}><RiTwitterXFill className="get-in-touch-icons-socialmedia" /></a>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                    <div className='get-in-touch-form-maincontainer'>
                                        <div className='get-in-touch-form-subcontainer'>
                                            <div className='get-in-touch-form-container'>
                                                <h2>Send a Message</h2>
                                                <form className='get-in-touch-form'>
                                                    <label>Name</label>
                                                    <InputText className="get-in-touch-form-input" name="name" value={contactFormData.name} onChange={handleChange} />
                                                    {
                                                        errors.name &&
                                                        <p className="contact-error-message">{errors.name}</p>
                                                    }
                                                    <label>Email</label>
                                                    <InputText className="get-in-touch-form-input" name="email" value={contactFormData.email} onChange={handleChange} />
                                                    {
                                                        errors.email &&
                                                        <p className="contact-error-message">{errors.email}</p>
                                                    }
                                                    <label>Message</label>
                                                    <InputTextarea className="get-in-touch-form-input-text-area" rows={5} cols={30} name="message" value={contactFormData.message} onChange={handleChange} />
                                                    {
                                                        errors.message &&
                                                        <p className="contact-error-message">{errors.message}</p>
                                                    }
                                                </form>
                                            </div>
                                            <div className='get-in-touch-form-button-container'>
                                                <Button
                                                    label={loading ? "Submitting..." : "Submit"}
                                                    icon={loading ? "pi pi-spin pi-spinner" : null}
                                                    disabled={loading}
                                                    onClick={handleSubmit}
                                                />
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div className='contact-us-map-container'>
                            <iframe src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3948.513081044267!2d77.3428169748236!3d8.251616391781926!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x3b04f844dc2cec25%3A0x9701a24a10a784f4!2sNoorul%20Islam%20College!5e0!3m2!1sen!2sin!4v1740995771964!5m2!1sen!2sin" className="contact-us-map" width="600" height="450" allowfullscreen="" loading="lazy" referrerpolicy="no-referrer-when-downgrade"></iframe>
                        </div>
                    </div>
                    <Footer />
                </div>
            </div>
        </>
    )
}



export default ContactUs